import OrganizationsStore from '../stores/observables/OrganizationsStore';
import { t } from './hook/useI18n';

export const DEFAULT_LANGUAGE = { language: 'English', value: 'en' };

export const LANGUAGES = [
  { language: 'German', value: 'de' },
  { language: 'Spanish', value: 'es' },
  { language: 'French', value: 'fr' },
];

export const getOrganizationLanguages = () => {
  const currentOrganization = OrganizationsStore.getCurrentOrganization();

  if (!currentOrganization || !currentOrganization?.languages) {
    return [DEFAULT_LANGUAGE];
  }

  const orgLanguages = LANGUAGES.filter(({ value }) =>
    currentOrganization.languages?.includes(value)
  );

  return [DEFAULT_LANGUAGE, ...orgLanguages];
};

/**
 * Returns the company's default language from the MT platform auth context,
 * filtered to DSR-supported languages (en/de/es/fr).
 * Falls back to English if the company default is not a DSR-supported language.
 *
 * Source: useUserAuth().company.defaultLanguage (MT auth JWT)
 * Same source used by dsr-ui-containers/src/hocs/withLanguage/index.tsx
 */
export function getDefaultOrganizationLanguage(
  companyDefaultLanguage?: string
): string {
  const dsrSupported = getOrganizationLanguages().map((l) => l.value); // ['en','de','es','fr']
  return companyDefaultLanguage && dsrSupported.includes(companyDefaultLanguage)
    ? companyDefaultLanguage
    : DEFAULT_LANGUAGE.value; // 'en'
}

export const pluralizeLabel = (count: number, key: string) =>
  t(`plural_handler`, {
    count,
    one: t(key),
    other: t(`${key}_plural`),
  });

export const setHtmlLang = () => {
  const browserLanguage =
    (navigator.languages &&
      navigator.languages.length &&
      navigator.languages[0]) ||
    navigator.language ||
    'en';

  document.documentElement.lang = browserLanguage;
};

export const getLanguageName = (language: string): string | undefined =>
  getOrganizationLanguages().find(({ value }) => language === value)?.language;
